import { MatSlideToggleDefaultOptions } from "@angular/material/slide-toggle";

export const slideToggleDefaultOptions: MatSlideToggleDefaultOptions = {
  // the legacy slide toggle had a plain thumb, without MDC's check/minus icons
  hideIcon: true
};
